export const initGA = () => {
    if (window.gtag) return;
  
    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    const trackingId = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
    const script = document.createElement('script');
    script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
    script.async = true;
    script.onload = () => {
      gtag('js', new Date());
      gtag('config', 'G-GMYT7QSZ5Q');
    };
    document.head.appendChild(script);
  };
  
  // Track page views (important for SPA)
  export const trackPageView = (path) => {
    window.gtag('config', 'G-GMYT7QSZ5Q', {
      page_path: path,
    });
  };